(function () {
  document.documentElement.setAttribute('data-ssw-version', 'v120');
  if (window.__sswMainInit) return;
  window.__sswMainInit = true;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var touch = window.matchMedia('(hover: none)').matches;

  function init() {
    var reveals = document.querySelectorAll('.ssw-reveal:not(.in)');
    if (!reduced && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.15 });
      reveals.forEach(function (el) { io.observe(el); });
    } else {
      reveals.forEach(function (el) { el.classList.add('in'); });
    }

    function countUp(el) {
      var target = parseInt(el.getAttribute('data-count'), 10);
      var dur = 1400, start = performance.now();
      function tick(t) {
        var p = Math.min((t - start) / dur, 1);
        el.textContent = Math.round(target * (1 - Math.pow(1 - p, 3))).toLocaleString('de-DE');
        if (p < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    }
    var counters = document.querySelectorAll('[data-count]');
    if (!reduced && 'IntersectionObserver' in window) {
      var cio = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) { countUp(e.target); cio.unobserve(e.target); }
        });
      }, { threshold: 0.6 });
      counters.forEach(function (el) { cio.observe(el); });
    } else {
      counters.forEach(function (el) {
        el.textContent = parseInt(el.getAttribute('data-count'), 10).toLocaleString('de-DE');
      });
    }

    if (!reduced && !touch) {
      document.querySelectorAll('.ssw-card').forEach(function (card) {
        if (card.dataset.sswTilt) return;
        card.dataset.sswTilt = '1';
        var max = 5;
        card.addEventListener('mousemove', function (e) {
          var r = card.getBoundingClientRect();
          var rx = ((e.clientY - r.top) / r.height - 0.5) * -2 * max;
          var ry = ((e.clientX - r.left) / r.width - 0.5) * 2 * max;
          card.style.transform = 'rotateX(' + rx.toFixed(2) + 'deg) rotateY(' + ry.toFixed(2) + 'deg) translateY(-3px)';
        });
        card.addEventListener('mouseleave', function () {
          card.style.transition = 'transform .35s ease, border-color .2s ease';
          card.style.transform = '';
          setTimeout(function () { card.style.transition = 'border-color .2s ease'; }, 380);
        });
      });
    }

    if (!reduced) {
      document.querySelectorAll('.ssw-marquee-track').forEach(function (track) {
        if (track.dataset.sswVel) return;
        track.dataset.sswVel = '1';
        track.style.animation = 'none';
        var x = 0, base = 0.6, lastY = window.scrollY, boost = 0;
        function loop() {
          var y = window.scrollY;
          boost += (y - lastY) * 0.12;
          boost *= 0.92;
          lastY = y;
          x -= base + Math.abs(boost);
          var half = track.scrollWidth / 2;
          if (half > 0 && -x >= half) x += half;
          track.style.transform = 'translateX(' + x.toFixed(1) + 'px)';
          requestAnimationFrame(loop);
        }
        requestAnimationFrame(loop);
      });
    }

    document.querySelectorAll('.ssw-btn--primary').forEach(function (btn) {
      if (btn.dataset.sswSpark) return;
      btn.dataset.sswSpark = '1';
      btn.addEventListener('click', function (e) {
        if (reduced) return;
        for (var i = 0; i < 8; i++) {
          var s = document.createElement('span');
          s.className = 'ssw-spark';
          s.style.left = e.clientX + 'px';
          s.style.top = e.clientY + 'px';
          document.body.appendChild(s);
          var angle = (i / 8) * Math.PI * 2;
          var dist = 34 + Math.random() * 14;
          s.animate([
            { transform: 'translate(-50%,-50%) rotate(' + angle + 'rad) translateY(0) scaleY(1)', opacity: 1 },
            { transform: 'translate(-50%,-50%) rotate(' + angle + 'rad) translateY(-' + dist + 'px) scaleY(.3)', opacity: 0 }
          ], { duration: 420, easing: 'cubic-bezier(.2,.7,.3,1)' }).onfinish = (function (el) {
            return function () { el.remove(); };
          })(s);
        }
      });
    });
  }

  function closeAllSubnavs(except) {
    document.querySelectorAll('.ssw-nav li.open, .ssw-mmenu-group.open').forEach(function (el) {
      if (el === except) return;
      el.classList.remove('open');
      var c = el.querySelector('.ssw-nav-caret');
      if (c) c.setAttribute('aria-expanded', 'false');
    });
  }
  document.addEventListener('click', function (e) {
    var arrow = e.target.closest('.ssw-rev-arrow');
    if (arrow) {
      e.preventDefault();
      var shell = arrow.closest('.ssw-reviews-shell');
      var track = shell && shell.querySelector('.ssw-reviews-track');
      if (track) {
        var card = track.querySelector('.ssw-rev-card');
        var amt = (card ? card.offsetWidth : 320) + 22;
        track.scrollBy({ left: arrow.dataset.dir === 'prev' ? -amt : amt, behavior: 'smooth' });
      }
      return;
    }
    var inc = e.target.closest('.ssw-inc-toggle');
    if (inc) {
      e.preventDefault();
      e.stopPropagation();
      var box = inc.closest('.ssw-inc');
      var isOpen = box.classList.toggle('open');
      inc.setAttribute('aria-expanded', String(isOpen));
      return;
    }
    var caret = e.target.closest('.ssw-nav-caret');
    if (caret) {
      e.preventDefault();
      var item = caret.closest('li.has-sub, .ssw-mmenu-group');
      if (!item) return;
      var open = item.classList.contains('open');
      closeAllSubnavs(item);
      item.classList.toggle('open', !open);
      caret.setAttribute('aria-expanded', String(!open));
      return;
    }
    if (!e.target.closest('.ssw-nav')) closeAllSubnavs(null);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllSubnavs(null);
  });

  (function () {
    if (window.__sswSmartHeader) return;
    window.__sswSmartHeader = true;
    var lastY = window.scrollY, ticking = false;
    function update() {
      var header = document.querySelector('.ssw-header');
      if (header) {
        var y = window.scrollY;
        var menuOpen = header.querySelector('.open');
        if (y <= 120 || y < lastY - 1 || menuOpen) {
          header.classList.remove('ssw-header--hidden');
        } else if (y > lastY + 2) {
          header.classList.add('ssw-header--hidden');
        }
        lastY = y;
      }
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
  })();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();

(function () {
  function karten() {
    var liste = document.querySelectorAll('iframe[data-ssw-karte]:not([src])');
    if (!liste.length) return;
    function laden(f) { if (!f.getAttribute('src')) f.setAttribute('src', f.getAttribute('data-ssw-karte')); }
    if (!('IntersectionObserver' in window)) { liste.forEach(laden); return; }
    var io = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) { if (e.isIntersecting) { laden(e.target); io.unobserve(e.target); } });
    }, { rootMargin: '300px 0px' });
    liste.forEach(function (f) { io.observe(f); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', karten); else karten();
  document.addEventListener('shopify:section:load', karten);
})();
